import React from "react";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { useTranslation } from "react-i18next";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import DockLock from "./DockLock";
import Tasks from "./Tasks";
import { Link } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    outline: "none",
    border: 0,
    background: "transparent",
  },
  drop_button: {
    outline: "none !important",
  },
}));

export enum TabValue {
  Lock,
  Tasks,
}

const Menu = ({ user }: any) => {
  const { t } = useTranslation("shared");
  const classes = useStyles();
  const [alignment, setAlignment] = React.useState<TabValue>(TabValue.Lock);

  const handleAlignment = (event: any, newAlignment: TabValue) => {
    setAlignment(newAlignment);
  };
  return (
    <PopupState variant="popover">
      {(popupState) => {
        return (
          <div style={{ display: "contents" }}>
            <button className={classes.root} {...bindTrigger(popupState)}>
              <FormatListBulletedIcon />
            </button>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <Box p={2} style={{ height: 500, width: 400 }}>
                <Box style={{ height: "90%", overflow: "auto" }}>
                  <Tabs
                    value={alignment}
                    onChange={handleAlignment}
                    aria-label="simple tabs example"
                    variant="fullWidth"
                  >
                    <Tab label={t("dropmenu.docLock")} value={TabValue.Lock} />
                    <Tab label={t("dropmenu.myTasks")} value={TabValue.Tasks} />
                  </Tabs>
                  {alignment === TabValue.Lock && (
                    <DockLock closePopover={popupState.close} />
                  )}
                  {alignment === TabValue.Tasks && <Tasks user={user.user} />}
                </Box>

                <Box style={{ height: "10%" }}>
                  <GetLinkMyWork
                    closePopover={popupState.close}
                    alignment={alignment}
                  />
                </Box>
              </Box>
            </Popover>
          </div>
        );
      }}
    </PopupState>
  );
};

const GetLinkMyWork = ({ closePopover, alignment }: any) => {
  const { t } = useTranslation("shared");
  const pathName =
    alignment === TabValue.Lock ? "editableDocuments" : "myTasks";

  return (
    <Box textAlign="center">
      <p>…</p>
      <Link
        style={{ paddingBottom: 10 }}
        onClick={() => closePopover()}
        to={{
          pathname: `/` + pathName,
        }}
      >
        {t("navmenu.showMore")}
      </Link>
    </Box>
  );
};

export default Menu;
